import React from "react";
import NavBar from "../components/NavBar";
import styles from "../styling/resourcePage.module.css";

function ResourcePage() {
  return (
    <>
      <NavBar />
      <div className={styles["resource-page"]}>
        <div className={styles["resource-header"]}>
          <h1>Resources</h1>
          <p className={styles["header-description"]}>
            Resources and opportunities to support your founder journey with
            Pantheon
          </p>
        </div>

        <div className={styles["office-hours-card"]}>
          <div className={styles["office-hours-content"]}>
            <h2>Office Hours</h2>
            <p className={styles["office-hours-description"]}>
              Book a 30-minute session with our team to discuss your startup,
              get feedback, and ask questions.
            </p>
            <a
              href="https://calendly.com/nathannl/30-minute-meeting"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["office-hours-button"]}
            >
              Book Office Hours
            </a>
          </div>
        </div>

        <div className={styles["resource-card"]}>
          <div className={styles["resource-content"]}>
            <h2>$2,500 OpenAI Credits</h2>
            <p className={styles["resource-description"]}>
              Get access to $2,500 in OpenAI API credits to power your AI
              projects
            </p>

            <div className={styles["steps-container"]}>
              <div className={styles["step"]}>
                <div className={styles["step-number"]}>1</div>
                <div className={styles["step-content"]}>
                  <p>Sign up for an OpenAI account</p>
                  <a
                    href="https://platform.openai.com/signup"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["resource-link"]}
                  >
                    Sign up here
                  </a>
                </div>
              </div>

              <div className={styles["step"]}>
                <div className={styles["step-number"]}>2</div>
                <div className={styles["step-content"]}>
                  <p>Enter your billing details (required)</p>
                  <a
                    href="https://platform.openai.com/account/billing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["resource-link"]}
                  >
                    Add billing details
                  </a>
                </div>
              </div>

              <div className={styles["step"]}>
                <div className={styles["step-number"]}>3</div>
                <div className={styles["step-content"]}>
                  <p>
                    Apply for credits and enter the email associated with your
                    OpenAI account
                  </p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSf9OWVil2t2L--V--Cpel702IC3IxQnrFuFcUFFnMCpvFFoAw/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["resource-link"]}
                  >
                    Apply for credits
                  </a>
                </div>
              </div>

              <div className={styles["step"]}>
                <div className={styles["step-number"]}>4</div>
                <div className={styles["step-content"]}>
                  <p>Enter the unique referral code:</p>
                  <div className={styles["referral-code"]}>pantheon_2025</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles["resource-card"]}>
          <div className={styles["resource-content"]}>
            <h2>AWS Credits</h2>
            <p className={styles["resource-description"]}>
              Get access to AWS credits to power your cloud infrastructure
            </p>
            <div className={styles["coming-soon"]}>Coming soon...</div>
          </div>
        </div>

        <div className={styles["resource-card"]}>
          <div className={styles["resource-content"]}>
            <h2>Legal Services</h2>
            <p className={styles["resource-description"]}>
              Get access to legal services and discounts through our partnership
              with Gunderson
            </p>
            <a
              href="mailto:nathan@gmail.com?subject=legal discounts @gunderson"
              className={styles["resource-link"]}
            >
              Contact Nathan
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResourcePage;
